/**
 just static keys for login page
 */
const loginPageKeys = {
    EST: {
        Login: 'Logi sisse',
        mainSlogan: 'Töö kiirem ja efektiivsem',
        buttonLabel: 'Hakkan pihta',
        bottomText: 'võidab see, kellel on rohkem Ektaco tooteid',
        reselectCompany: 'Palun vali firma',
        next: 'Järgmine',
        back: 'Tagasi',
        done: 'Tehtud',
        departments: 'Osakonnad',
        employees: 'Töötajad',
        actions: 'Toimingud',
        laws: 'Seadused',
        payrollSoftware: 'Palgaarvestuse tarkvara',
        modules: 'Moodulid',
        overviewAndFinish: 'Ülevaade ja viimistlus',
        updateAvailable: 'Uuendused on saadaval, värskenda lehte?\n',
        reload: 'Värskenda'
    },
    ENG: {
        Login: 'Login',
        mainSlogan: 'Increased productivity and effectiveness',
        buttonLabel: 'Let’s get it done',
        bottomText: 'the more products of Ektaco the merrier',
        reselectCompany: 'Please choose company',
        next: 'Next',
        back: 'Back',
        done: 'Done',
        departments: 'Departments',
        employees: 'Employees',
        actions: 'Actions',
        laws: 'Laws',
        payrollSoftware: 'Payroll software',
        modules: 'Modules',
        overviewAndFinish: 'Overview and Finish',
        updateAvailable: 'Updates are available, reload the page?',
        reload: 'Reload'
    },
    RUS: {
        Login: 'Вход',
        mainSlogan: 'Увеличение производительности и эффективности',
        buttonLabel: 'Давайте сделаем это',
        bottomText: 'чем больше продуктов Ektaco, тем лучше',
        reselectCompany: 'Пожалуйста, выберите компанию',
        next: 'Дальше',
        back: 'Назад',
        done: 'Завершить',
        departments: 'Отделы',
        employees: 'Сотрудники',
        actions: 'Работы',
        laws: 'Законы',
        payrollSoftware: 'Расчет заработной платы',
        modules: 'Модули',
        overviewAndFinish: 'Обзор и завершение',
        updateAvailable: 'Доступны обновления, перезагрузить страницу?',
        reload: 'Перезагрузить'
    }
};
export default loginPageKeys;
